<template>
<span>
      <div class="container container-paddingt pl-0 pl-lg-3">
      <div class="row">
        <h1 class="col-lg-10 col-md-12 title dark-grey roboto-style">What our clients say about us</h1>
      </div>
      <div class="row mt-2 xs_marginb">
        <p class="col-lg-10 col-md-12 description inter-style medium-grey mb-0">See why top companies choose Unknown Software to develop software solutions.</p>
      </div>
      <div class="row container-paddingb" v-bind:style="width > 1023 ? 'margin-top:60px' : ''">
        <div class="col-lg-6 col-md-12">
          <div class="row">
            <div class="col-lg-4 col-md-3 col-4"><img class="img-fluid" src=".././assets/testimonial1.png"/></div>
            <div class="col-lg-8 col-md-9 col-8 small-description inter-style medium-grey px-0">
              <quote></quote>
              <p ref="longer_text" class=" col-md-12 pl-0 mt-3 font-italic">Web programming has no secrets for Unknown Software. They have an excellent team of programmers and team-managers. During the time we worked together for UPC Romania, their skills and knowledge were a milestone in finding the best solutions for any development issues.</p>
              <p class="xs-descr dark-grey">Irina Bucurenciu <br/>Manager Online Marketing @ UPC</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 xs_margint">
          <div class="row">
            <div class="col-lg-4 col-md-3 col-4"><img class="img-fluid" src=".././assets/testimonial2.png"/></div>
            <div class="col-lg-8 col-md-9 col-8 title small-description inter-style medium-grey px-0">
              <quote></quote>
              <p ref="shorter_text" class=" col-md-12 pl-0 mt-3 font-italic">Unknown Software is a fair and firm business partner and yet displaying a great level of flexibility requested by innovation projects. They are a true business partner, taking ownership of the scope of the project and putting a lot of personal energy in it.</p>
              <p class="xs-descr dark-grey">Tudor Ghiurca <br/>Youth Segment Director @ Vodafone</p>
            </div>
          </div>
        </div>
    </div>
    </div>
</span>
</template>

<script>
    import quote from './quote';
    export default {
        components: {
            quote: quote
        },
        data() {
            return {
                width: 0
            }
        },
        computed: {
            windowWidth: {
                get: function () {
                    return this.width;
                },
                set: function (val) {
                    this.width = val;
                }

            }
        },
        methods: {
            resizeEvent() {
                this.windowWidth = window.innerWidth;
                this.$refs.shorter_text.style.height = this.$refs.longer_text.offsetHeight + 'px';
            }
        },
        mounted() {
            this.width = window.innerWidth;
            window.addEventListener("resize", this.resizeEvent);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resizeEvent);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/testemonials.vue